export default __webpack_public_path__ + "locales/ro/FilesSettings.json?hash=fdcc91e05d63bf3af43ee9c9ed1c9895";